<script>
import { Line } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import merge from 'lodash/merge'

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    pointLabel: {
      type: Boolean,
      default: false,
    },
    yLabel: {
      type: String,
      required: false,
      default: '',
    },
    yAxesAdditional: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    computedData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
        ...this.data,
      }
    },
    computedOptions() {
      const defaultOptions = {
        defaultFontColor: '#8791af',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: this.pointLabel,
            align: 'top',
            anchor: 'end',
            clamp: true,
            color: (context) =>
              context.dataset.borderColor || context.dataset.backgroundColor || '#253858',
            font: {
              size: 11,
              weight: 'normal',
            },
            formatter: (value, context) => {
              if (value === null || value === undefined || value === '') return ''
              const unit = context.dataset.unit || ''
              return unit ? `${value} ${unit}` : value
            },
          },
        },
        layout: {
          padding: {
            top: this.pointLabel ? 20 : 0,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
              ticks: {
                autoSkip: true,
                autoSkipPadding:
                  this.datasets[0] && this.datasets[0].data.length == 0 ? 60 : 40,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel,
              },
            },
            this.yAxesAdditional,
          ],
        },
        legend: {
          position: 'bottom',
        },
      }

      const options = merge({}, defaultOptions, this.options)
      if (Array.isArray(this.options.scales?.yAxes)) {
        options.scales.yAxes = this.options.scales.yAxes.map((axis) => merge({}, axis))
      }
      return options
    },
  },
  mounted() {
    if (this.pointLabel) {
      this.addPlugin(ChartJSPluginDatalabels)
    }

    this.renderChart(this.computedData, this.computedOptions)
  },
}
</script>
